/* SOFT SKILLS ABILITIES */
export const GET_SOFTSKILLS_ABILITIES = "GET_SOFTSKILLS_ABILITIES"
export const GET_SOFTSKILLS_ABILITIES_SUCCESS =
  "GET_SOFTSKILLS_ABILITIES_SUCCESS"
export const GET_SOFTSKILLS_ABILITIES_ERROR = "GET_SOFTSKILLS_ABILITIES_ERROR"
